import type { IPropertyBag } from '@deity-io/di-data-basics';
import { Box, Button, FlexLayout, H6, Icon } from '@deity-io/portal-ui';
import ConfirmDeleteVariableModal from 'components/Package/VariablesTab/ConfirmDeleteVariableModal';
import CreateEditVariableModal from 'components/Package/VariablesTab/CreateEditVariableModal';
import EnvironmentVariableContainer from 'components/Package/VariablesTab/EnvironmentVariableContainer';
import type { FC } from 'react';
import { useState } from 'react';

type VariableWrapperProps = {
  variable: IPropertyBag;
  variableKey: string;
  locked?: boolean;
  onUpdate?: (key: string, value: IPropertyBag | undefined) => void;
};
const VariableWrapper: FC<VariableWrapperProps> = ({ variable, variableKey, locked, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <>
      <Box pb={3}>
        <FlexLayout alignItems="center" justifyContent="space-between" sx={{ pb: 1 }}>
          <H6>{variableKey}</H6>

          <FlexLayout>
            <Button
              disabled={locked}
              size="small"
              startIcon={<Icon icon="edit" />}
              onClick={() => setIsModalOpen(true)}
            />
            <Button
              sx={{ ml: 1 }}
              disabled={locked}
              size="small"
              startIcon={<Icon icon="delete" />}
              onClick={() => setIsDeleteModalOpen(true)}
            />
          </FlexLayout>
        </FlexLayout>
        <EnvironmentVariableContainer values={variable} variableKey={variableKey} disabled />
        <Box pt={4}>
          <hr />
        </Box>
      </Box>

      {isModalOpen && (
        <CreateEditVariableModal
          key={variableKey}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          variable={variable}
          variableKey={variableKey}
          onUpdate={onUpdate}
        />
      )}
      {isDeleteModalOpen && (
        <ConfirmDeleteVariableModal
          isOpen={isDeleteModalOpen}
          variableKey={variableKey}
          setIsOpen={setIsDeleteModalOpen}
          onUpdate={onUpdate}
        />
      )}
    </>
  );
};

export default VariableWrapper;
